import { render, staticRenderFns } from "./AlteraMinhaSenha.vue?vue&type=template&id=d8414608&"
import script from "./AlteraMinhaSenha.vue?vue&type=script&lang=js&"
export * from "./AlteraMinhaSenha.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports